import { render, staticRenderFns } from "./AssetLocationArea.vue?vue&type=template&id=815da612&scoped=true&"
import script from "./AssetLocationArea.vue?vue&type=script&lang=js&"
export * from "./AssetLocationArea.vue?vue&type=script&lang=js&"
import style0 from "./AssetLocationArea.vue?vue&type=style&index=0&id=815da612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815da612",
  null
  
)

export default component.exports